import { API_BASE_URL } from '../../../api/config';
import fetchService from '../../../services/fetchService';
import { CredentialEntity, CredentialType, CredentialFields } from '../types/entity';

const BASE = `${API_BASE_URL}/credentials`;

export interface CreateCredentialPayload {
  name: string;
  credentialType: CredentialType;
  fields: Record<string, string>;
  service?: string;
  url?: string;
  username?: string;
  description?: string;
  tags?: string[];
}

export interface UpdateCredentialPayload {
  name?: string;
  fields?: Record<string, string>;
  service?: string;
  url?: string;
  username?: string;
  description?: string;
  tags?: string[];
  /** Set to entity ID to link, or empty string to unlink */
  linkedEntityId?: string;
}

export const credentialsService = {
  async list(filters?: { credentialType?: CredentialType; service?: string }): Promise<CredentialEntity[]> {
    const params = new URLSearchParams();
    if (filters?.credentialType) params.set('credentialType', filters.credentialType);
    if (filters?.service) params.set('service', filters.service);
    const url = params.toString() ? `${BASE}?${params}` : BASE;
    return fetchService(url, { method: 'GET' });
  },

  async get(id: string): Promise<CredentialEntity & { skeleton: { fields: CredentialFields } }> {
    return fetchService(`${BASE}/${id}`, { method: 'GET' });
  },

  async create(payload: CreateCredentialPayload): Promise<CredentialEntity> {
    return fetchService(BASE, { method: 'POST', body: JSON.stringify(payload) });
  },

  async update(id: string, payload: UpdateCredentialPayload): Promise<CredentialEntity> {
    return fetchService(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(payload) });
  },

  async delete(id: string): Promise<void> {
    await fetchService(`${BASE}/${id}`, { method: 'DELETE' });
  },
};
